<template>
  <div>
    <section
      class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    >
      <div class="title">יצירת תור</div>
      <a
        class="m_bt_head head_go_back flex m-flex--center is-svg-w"
        @click.prevent="$router.go(-1)"
      >
        <ArrowBackSvgMobile />
      </a>
      <a
        class="m_bt_head head_save"
        href="javascript:void(0);"
        @click.prevent="saveApp"
      >
        שמירה
      </a>
    </section>

    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue no_mobile"
      style="background-image:url('assets/img/layout/bg_head.jpg');"
    >
      <div class="popup_close close-animate">
        <a @click.prevent="goBackRoute">
          <CloseSvg />
        </a>
      </div>

      <a class="no_mobile link_goback" href="" @click.prevent="onPrevStage">
        חזרה
        <ArrowBackSvg />
      </a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold"> יצירת תור - {{ activeDoctor.name }}</span>
        </h1>
        <div class="add_step_all flex flex--content--center">
          <div class="add_step" :class="stage < 1 ? '' : 'active'">1</div>
          <div class="add_step" :class="stage < 2 ? '' : 'active'">2</div>
          <div class="add_step" :class="stage < 3 ? '' : 'active'">3</div>
          <div class="add_step" :class="stage < 4 ? '' : 'active'">4</div>
        </div>
      </div>
    </section>

    <ValidationObserver ref="newAppointmentForm">
      <form
        @submit.prevent="saveApp"
        v-promise-btn="{ action: 'submit' }"
        name="appointmentForm"
        autocomplete="off"
      >
        <section class="add_new_inner">
          <div
            v-show="stage === 2 || (isMobile && !isBlockingApp)"
            class="inner_group bg--white"
          >
            <div class="subtitle center no_mobile">פרטי מטופל</div>
            <div
              class="desk_inner_width desk-flex desk-flex--top desk-flex--start"
            >
              <div v-if="isMobile" class="add_new_row flex desk-hide">
                <label for="name" class="add_new_row_col1 ">שם מלא</label>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="name"
                        type="text"
                        name="name"
                        v-model="appointment.name"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div v-if="!isMobile" class="add_new_row_4 flex no_mobile">
                <label for="first_name" class="add_new_row_col1 "
                  >שם פרטי*</label
                >
                <div class="add_new_row_col2">
                  <validation-provider
                    name="first_name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="first_name"
                        type="text"
                        name="first_name"
                        v-model="appointment.first_name"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div v-if="!isMobile" class="add_new_row_4 flex no_mobile">
                <label for="last_name" class="add_new_row_col1 "
                  >שם משפחה*</label
                >
                <div class="add_new_row_col2">
                  <validation-provider
                    name="last_name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="last_name"
                        type="text"
                        name="last_name"
                        v-model="appointment.last_name"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row_4 flex">
                <label fpr="birth_date" class="add_new_row_col1"
                  >תאריך לידה*</label
                >
                <div class="add_new_row_col2">
                  <validation-provider
                    name="birth_date"
                    :rules="isBlockingApp ? '' : 'required|birth_date'"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="birth_date"
                        type="text"
                        name="birth_date"
                        placeholder="dd/mm/yyyy"
                        v-mask="['##/##/####']"
                        v-model="appointment.birth_date"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row_4 flex">
                <label for="gender" class="add_new_row_col1">מגדר</label>
                <validation-provider
                  class="add_new_row_col2"
                  name="gender"
                  v-slot="{ errors }"
                >
                  <div class="input-opacity">
                    <select2
                      name="gender"
                      dir="rtl"
                      v-model="appointment.gender"
                    >
                      <option value="">בחר מין</option>
                      <option value="male">זכר</option>
                      <option value="female">נקבה</option>
                    </select2>
                  </div>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="add_new_row_4 flex">
                <label for="phone" class="add_new_row_col1">נייד*</label>
                <div class="add_new_row_col2">
                  <validation-provider
                    name="phone"
                    mode="lazy"
                    :rules="
                      isBlockingApp
                        ? {}
                        : {
                            regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/,
                            required: true
                          }
                    "
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="phone"
                        type="tel"
                        name="phone"
                        :rules="{
                          regex: /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/
                        }"
                        v-model="appointment.phone"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="add_new_row_4 flex">
                <label for="tel" class="add_new_row_col1">טלפון נוסף</label>
                <div class="add_new_row_col2">
                  <div class="input-opacity">
                    <input
                      id="tel"
                      type="tel"
                      name="second_phone"
                      v-model="appointment.phone2"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="add_new_row_4 flex">
                <label for="lang" class="add_new_row_col1"
                  >שפה מועדפת לשליחת הודעות תזכורת למטופל</label
                >
                <div class="add_new_row_col2 text--right">
                  <div class="input-opacity">
                    <select2 name="lang" id="lang" v-model="appointment.lang">
                      <option value="">בחירה</option>
                      <option value="עברית">עברית</option>
                      <option value="אנגלית">אנגלית</option>
                      <option value="רוסית">רוסית</option>
                      <option value="ערבית">ערבית</option>
                    </select2>
                    <input type="hidden" name="user_language" />
                  </div>
                </div>
              </div>
              <div class="add_new_row_4 flex">
                <label for="email" class="email-label add_new_row_col1 "
                  >אימייל</label
                >
                <div class="email-wrapper add_new_row_col2">
                  <validation-provider
                    name="email"
                    :rules="{
                      emailRegex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                    }"
                    v-slot="{ errors }"
                  >
                    <div class="input-opacity">
                      <input
                        id="email"
                        type="text"
                        name="email"
                        v-model="appointment.email"
                        autocomplete="off"
                      />
                    </div>
                    <span class="error-message" v-if="errors.length > 0">{{
                      errors[0]
                    }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="form_submit center no_mobile">
              <button class="bt_blue" @click.prevent="onNextStage">
                הבא
              </button>
            </div>
          </div>
          <!-- End inner_group stp 1 -->

          <h2
            v-show="stage === 3 || isMobile"
            class="subtitle_inner mobile_only"
          >
            באפשרותך לבחור מועד באופן ידני או מתוך רשימת תורים פנויים:
          </h2>
          <div v-if="stage === 3 || isMobile" class="inner_group bg--white">
            <div class="subtitle center no_mobile">
              באפשרותך לבחור מועד באופן ידני או מתוך רשימת תורים פנויים:
            </div>

            <app-select-time
              v-if="
                Appoitments.selectedBlock && Appoitments.selectedBlock.length
              "
              :appointment="appointment"
              :isValid="checkValidTime"
              :isBlockingApp="isBlockingApp"
            />

            <div class="error note-error mobile_only" v-if="invalidTime">
              לא ניתן לזמן תור , נסה שעה שונה
            </div>
            <div class="form_submit center no_mobile">
              <button class="bt_blue" @click.prevent="onNextStage">
                {{ isBlockingApp ? "שמירה" : "הבא" }}
              </button>
            </div>
          </div>
          <!-- END inner_group stp 2 -->

          <div
            class="desk_inner_width step-4-docs"
            v-show="stage === 4 || isMobile"
          >
            <div class="subtitle center no_mobile">
              מסמכים והערות
            </div>
            <div
              v-show="!isBlockingApp"
              class="inner_group bg--white step-4-docs-group"
            >
              <label for="file" class="add_new_row_col1 w-100">
                מסמכים מצורפים (ניתן להוסיף מסמך בסיומת pdf, jpg, png)
              </label>
              <div
                class="add_new_row_docs flex flex--start svg-block file-block"
              >
                <a
                  class="file_item relative flex desk-block"
                  v-for="(file, index) in appointment.files"
                  :key="index"
                >
                  <span @click.prevent="removeFile(index)" class="file-remove">
                    <CloseSvg />
                  </span>
                  <img class="no_mobile" src="/assets/img/svg/ic-file.svg" />
                  <span class="tx_file block">{{ file.name }}</span>
                </a>
                <div class="bt_upload relative flex desk-block">
                  <input
                    id="file"
                    type="file"
                    ref="files"
                    multiple
                    @change="handleFilesUpload"
                    @click="event => (event.target.value = null)"
                  />
                  <div class="ic-upload ease">
                    <UploadSvg />
                  </div>
                  <div class="tx_file ease">הוספת מסמך</div>
                </div>
              </div>
            </div>
            <div
              v-show="!isBlockingApp"
              class="inner_group bg--white desk-no-pad"
            >
              <div class="add_new_row flex step-4-docs-group">
                <label for="notes" class="add_new_row_col1 w-100"
                  >הערות לתצוגה ברשימת התורים (לשימוש המרפאה)
                </label>
                <div class="input_area_opcity add-border">
                  <textarea
                    id="notes"
                    name="notes"
                    v-model="appointment.notes"
                  ></textarea>
                </div>
              </div>
              <div class="add_new_row flex step-4-docs-group">
                <label for="notes_2" class="add_new_row_col1 w-100"
                  >הערות נוספות לשימוש המרפאה (לא יוצגו למטופל)
                </label>
                <div class="input_area_opcity add-border">
                  <textarea
                    id="notes_2"
                    name="notes_2"
                    v-model="appointment.notes2"
                  ></textarea>
                </div>
              </div>
            </div>
            <input
              type="hidden"
              name="selected_date"
              v-model="appointment.selectedDate"
            />
            <div class="form_submit center">
              <button class="bt_blue" type="submit">שמירה</button>
            </div>
          </div>
        </section>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import CloseSvg from "../../../assets/img/svg/close.svg";
import UploadSvg from "../../../assets/img/svg/upload.svg";
import ArrowBackSvg from "../../../assets/img/svg/arrow_r.svg";
import ArrowBackSvgMobile from "../../../assets/img/svg/arrow_back.svg";
import ConfirmNewApp from "../../Popups/ConfirmNewApp";
import HoursPop from "../../Popups/Hours";
import Error from "@/components/Popups/Error";
import ShortenHours from "@/components/Popups/ShortenHours";
import ClickOutside from "vue-click-outside";
import AppSelectTime from "./AppSelectTime.vue";
import { getHash } from "../../../utilities/hash.js";
import { uploadDocuments } from "../../../utilities/globals.js";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "AppAdd",
  data() {
    return {
      isBlockingApp: false,
      checkValidTime: false,
      selectedDateCal: new Date(),
      allExistBlocks: [],
      stage: 2,
      showAllDates: false,
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: false
      },
      appointment_id: "",
      block_id: "", // selected block
      start_date: "", // start_date
      end_date: "", // start_date
      selected_time: "", // selected time
      minActiveDates: false,
      activeDates: {},
      activeTimes: [],
      selectedDate: "",
      selected_block: {},
      need_to_short: false,
      error_need_to_short: false,
      error_out_of_block: false,
      error_contain_app: false,
      invalidTime: false,
      shortappointment: {},
      appointment: {
        name: "",
        birth_date: "",
        selectedDate: "",
        block_id: "",
        phone: "",
        phone2: "",
        lang: "",
        gender: "",
        date: "",
        duration: "",
        time: "",
        files: [],
        notes: "",
        notes2: "",
        first_name: "",
        last_name: "",
        email: ""
      }
    };
  },
  async mounted() {
    window.scrollTo({
      top: 0
    });
    // Get slots if not exist
    if (
      !this.Appoitments.selectedBlock ||
      !this.Appoitments.selectedBlock.length
    ) {
      await this.getSlots();
    }

    if (typeof this.$route.query.start != "undefined") {
      this.start_date = this.$route.query.start;
      this.appointment.date = this.$moment(this.start_date).format(
        "DD/MM/YYYY"
      );
      this.appointment.selectedDate = this.start_date;
      this.appointment.time = this.$moment(this.start_date).format("HH:mm");
      if (typeof this.$route.query.block_id != "undefined") {
        this.block_id = parseInt(this.$route.query.block_id);
        let allBlocks = this.Appoitments.selectedBlock;
        let selectedBlock = allBlocks.find(
          block => block.block_id == this.block_id
        );
        if (selectedBlock) this.selected_block = selectedBlock;
      }
      if (typeof this.$route.query.end != "undefined") {
        this.end_date = this.$route.query.end;
        let a = this.$moment(this.start_date);
        let b = this.$moment(this.end_date);
        let calcduration = b.diff(a, "minutes");
        if (calcduration > 0) {
          this.appointment.duration = calcduration;
        }
      }
    }
    if (this.Appoitments) {
      this.appointment.name =
        this.Appoitments.patient.first_name +
        " " +
        this.Appoitments.patient.last_name;

      this.appointment.first_name = this.Appoitments.patient.first_name;
      this.appointment.last_name = this.Appoitments.patient.last_name;

      if (
        this.Appoitments.patient.gender === "male" ||
        this.Appoitments.patient.gender === "זכר"
      ) {
        this.appointment.gender = "male";
      } else if (
        this.Appoitments.patient.gender === "female" ||
        this.Appoitments.patient.gender === "נקבה"
      ) {
        this.appointment.gender = "female";
      } else {
        this.appointment.gender = "לא הוגדר";
      }

      this.appointment.birth_date = this.$moment(
        this.Appoitments.patient.birth_date,
        "DD/MM/YYYY"
      ).format("DD/MM/YYYY");
      this.appointment.phone = this.Appoitments.patient.phone;
      let blocks = this.$store.state.Appoitments.selectedBlock;
      let times_arr = {};

      if (blocks) {
        blocks.map(block => {
          let tmp = {
            start: new Date(
              this.$moment(block.block_date, "DD/MM/YYYY").format("YYYY-MM-DD")
            ), // Required.
            end: new Date(
              this.$moment(block.block_date, "DD/MM/YYYY").format("YYYY-MM-DD")
            ), // Required.
            date: this.$moment(block.block_date, "DD/MM/YYYY").format(
              "DD/MM/YYYY"
            ), // Required.
            id: block.block_id,
            type: "block"
          };
          this.allExistBlocks.push(tmp);

          let availableTimes = block.available_time_slots_array;
          for (const index in availableTimes) {
            const slot = this.$moment(
              availableTimes[index][0],
              "YYYY-MM-DD HH:mm:ss"
            );
            const parsedDate = slot.format("DD/MM/YYYY");
            const parseTime = slot.format("HH:mm");
            if (!times_arr.hasOwnProperty(parsedDate)) {
              times_arr[parsedDate] = [];
            }
            let object = {
              id: availableTimes[index][4],
              time: parseTime
            };
            times_arr[parsedDate].push(object);
          }
        });

        this.activeDates = times_arr;
      }
    }

    if (this.Appoitments.patient.isBlockingApp) {
      this.isBlockingApp = true;
      this.stage = 3;
    }
  },
  beforeDestroy() {
    this.appointmentAbort();
  },
  methods: {
    ...mapMutations(["SET_APP_TIME_EDIT", "SET_BLOCK"]),
    uploadDocuments,
    getDocPath(doc) {
      if (doc && doc.path) return doc.path;
      return "";
    },
    async onNextStage() {
      const isValid = await this.$refs.newAppointmentForm.validate();
      if (isValid) {
        if (this.stage == 3) {
          this.checkValidTime = false;
          const appTimeEdit = this.$store.getters.appTimeEdit;
          if (
            appTimeEdit &&
            appTimeEdit.isValid &&
            appTimeEdit.date &&
            appTimeEdit.time &&
            appTimeEdit.duration
          ) {
            if (this.isBlockingApp) this.saveApp();
            else this.stage++;
          } else {
            this.checkValidTime = true;
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth"
            });
            return;
          }
        } else {
          this.stage++;
        }
        window.scrollTo(0, 0);
      }
    },
    onPrevStage() {
      if (this.stage === 2) {
        this.$router.go(-1);
      } else if (this.stage > 2) {
        this.stage--;
      }
    },
    saveApp() {
      return new Promise((resolve, reject) => {
        this.$refs.newAppointmentForm.validate().then(res => {
          if (res) {
            let new_birth_date = false;
            if (this.appointment.birth_date.split("/").length > 0) {
              new_birth_date = this.$moment(
                this.appointment.birth_date,
                "DD/MM/YYYY"
              ).format("YYYY-MM-DD");
            }
            let datetime = this.$moment(
              this.appTimeEdit.date,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD");
            datetime += "T" + this.appTimeEdit.time + ":00";

            let appointment = {
              block_id: this.appTimeEdit.block_id,
              datetime,
              //appointment_duration_min: this.selected_block.duration,
              appointment_duration_min: this.appTimeEdit.duration,
              appointment_id: this.appTimeEdit.appointment_id,
              first_name: !this.isMobile
                ? this.appointment.first_name
                : this.appointment.name.split(" ")[0],
              last_name: !this.isMobile
                ? this.appointment.last_name
                : this.appointment.name.split(" ")[1],
              passport: this.Appoitments.patient.id_num,
              phone: this.appointment.phone,
              second_phone: this.appointment.phone2,
              email: this.appointment.email,
              lang: this.appointment.lang,
              gender: this.appointment.gender,
              birth_date:
                new_birth_date == "Invalid date" ? "" : new_birth_date,
              notes: this.appointment.notes,
              general_notes: this.appointment.notes2,
              appointment_type: this.appointmentType.appointment_type,
              insurance: this.appointmentType.insurance,
              cost_patient: this.isBlockingApp
                ? "אחר"
                : this.appTimeEdit.selected_block.cost_patient,
              payment_method: this.isBlockingApp
                ? "אחר"
                : this.appTimeEdit.selected_block.payment_method.payment_method
            };
            // cost & payment method
            if (
              !this.isBlockingApp &&
              this.appointmentType &&
              this.appointmentType.blockFound
            ) {
              appointment.cost_patient =
                this.appointmentType.blockFound.cost_patient ?? "";
              appointment.payment_method =
                this.appointmentType.blockFound.payment_method ?? "";
            }
            // which passport
            if (this.appointmentType.passport_type) {
              appointment.passport_type = this.appointmentType.passport_type;
            }
            // if anesthesia reqiuerd
            if (this.appointmentType.anesthesia) {
              appointment.anesthesia = this.appointmentType.anesthesia;
            }
            localStorage.removeItem("appointmentLock");
            this.$API
              .scheduleAppointment(appointment)
              .then(res => {
                if (
                  (typeof res.appointment_id != "undefined" &&
                    res.appointment_id) ||
                  res === "approved"
                ) {
                  this.Appoitments.lastAppointmentDate = this.appTimeEdit.date;
                  this.uploadFiles();
                  this.$modal.show(ConfirmNewApp, {
                    isBlockingApp: this.isBlockingApp
                  });
                  this.appointment_id = "";
                } else {
                  this.$modal.show(Error);
                }
              })
              .catch(e => {
                reject();
              });
          } else {
            if (this.isMobile) {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }
            reject();
          }
        });
      });
    },
    handleFilesUpload() {
      let files = this.$refs.files.files;
      for (const filesKey in files) {
        if (files[filesKey] instanceof File) {
          this.appointment.files.push(files[filesKey]);
        }
      }
    },
    async uploadFiles() {
      await this.uploadDocuments(
        this.appointment.files,
        this.appTimeEdit.appointment_id
      );
    },
    removeFile(index) {
      this.appointment.files.splice(index, 1);
    },
    selectTime($event, time, date) {
      this.error_contain_app = "";
      this.error_out_of_block = "";
      this.error_need_to_short = "";
      this.selected_time = "";
      this.appointment.time = this.appointment.date = this.appointment.duration =
        "";
      if (time.id == this.block_id && time.time == this.selected_time) {
        this.appointmentAbort();
        return;
      }

      let allBlocks = this.Appoitments.selectedBlock;
      let newDate = this.$moment(date, "DD/MM/YYYY").format("DD/MM/YYYY");
      let selectedBlock = allBlocks.find(block => block.block_date == newDate);
      let parseddate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
      this.selectedDateCal = new Date(parseddate);
      let parsedtime = this.$moment(parseddate + "T" + time.time);
      this.selected_block = selectedBlock;
      this.selected_time = time.time;
      if (typeof selectedBlock != "undefined") {
        this.block_id = time.id;
        this.appointment.duration = selectedBlock.duration;
        let appointment_to_lock = {
          appointment: "lock",
          block_id: time.id,
          // datetime: parseddate + "_" + time.time + ":00",
          datetime: selectedBlock.available_time_slots_array[0][0],
          appointment_duration_min: selectedBlock.duration
          //lock_duration: 120
        };
        if (this.appointment_id) this.appointmentAbort();

        this.$API
          .appointmentLock(appointment_to_lock)
          .then(res => {
            if (typeof res.appointment_id == "undefined") {
              this.invalidTime = true;
            } else {
              let time_elm = document.getElementsByClassName("book_hure");
              for (let i in time_elm) {
                if (
                  time_elm[i].classList &&
                  time_elm[i].classList.contains("active")
                ) {
                  time_elm[i].classList.remove("active");
                }
              }
              $event.target.classList.add("active");

              this.invalidTime = false;
              this.appointment.date = date;
              this.appointment.time = time.time;
              this.appointment.selectedDate = parsedtime.format(
                "YYYY-MM-DDTHH:mm"
              );
              this.appointment_id = res.appointment_id;
            }
          })
          .catch(e => {
            this.$modal.show(Error);
          });
      }
    },
    appointmentAbort() {
      if (!this.appointment_id) return;
      this.$API
        .appointmentAbortLock(this.appointment_id)
        .then(res => {})
        .catch(e => {
          this.$modal.show(Error);
        });
    },
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/#" + hash);
    },
    async getSlots(duration = "0.5") {
      if (parseFloat(duration) > 1) return;

      const startdate = this.$moment().format("YYYY-MM-DD");
      const endtdate = this.$moment(startdate, "YYYY-MM-DD")
        .add(duration, "y")
        .format("YYYY-MM-DD");
      const activeDoctor = JSON.parse(localStorage.getItem("activeDoctor"));
      let doctorId = this.activeDoctor
        ? this.activeDoctor.id
        : activeDoctor
        ? activeDoctor.id
        : "";

      try {
        const res = await this.$API.getScheduleTable(
          doctorId,
          startdate,
          endtdate
        );

        if (!res || !res.data || !res.data.length) {
          const newDuration = (parseFloat(duration) + 0.5).toString();
          this.getSlots(newDuration);
          return;
        }

        let block = res.data.filter(b => b.appointment_type && b.insurance);
        await this.SET_BLOCK(block);
      } catch (error) {
        this.$modal.show(Error);
      }
    }
  },
  computed: {
    ...mapGetters([
      "patient",
      "activeDoctor",
      "activeUser",
      "appTimeEdit",
      "appointmentType"
    ]),
    ...mapState(["Appoitments"]),
    isMobile() {
      return window && window.innerWidth < 1200;
    },
    availableTimes() {
      var times_arr = [];
      if (this.Appoitments) {
        let blocks = this.Appoitments.selectedBlock;

        if (blocks) {
          blocks.map(block => {
            let availableTimes = block.available_time_slots_array;
            for (const index in availableTimes) {
              const slot = this.$moment(
                availableTimes[index][0],
                "YYYY-MM-DD HH:mm:ss"
              );
              const parsedDate = slot.format("DD/MM/YYYY");
              const parseTime = slot.format("HH:mm");
              if (!times_arr.hasOwnProperty(parsedDate)) {
                times_arr[parsedDate] = [];
              }
              let object = {
                id: availableTimes[index][4],
                time: parseTime
              };
              times_arr[parsedDate].push(object);
            }
          });
        }
        return times_arr;
      }
      return false;
    },
    getActiveDates() {
      if (!this.minActiveDates) {
        return this.activeDates;
      }

      let datesSet = Object.keys(this.activeDates)
        .filter(key => {
          let a = this.$moment(key, "DD/MM/YYYY");
          let b = this.$moment(this.minActiveDates, "DD/MM/YYYY");
          let calcduration = a.diff(b, "day");
          if (calcduration >= 0) {
            return true;
          }
          return false;
        })
        .reduce((obj, key) => {
          return Object.assign(obj, {
            [key]: this.activeDates[key]
          });
        }, {});

      return datesSet;
    }
  },
  directives: {
    ClickOutside
  },
  components: {
    CloseSvg,
    UploadSvg,
    ArrowBackSvg,
    ArrowBackSvgMobile,
    AppSelectTime
  }
};
</script>

<style scoped>
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.book_hours_slide {
  padding-left: 0px;
}

.swiper-container {
  width: 100%;
}

.error.note-error {
  color: #b00020;
  border-top: 2px solid;
}

.show_more_bt {
  display: block;
  color: black;
  text-decoration: underline;
  padding: 10px 0 20px;
}

.file-block {
  margin-block-start: 12px;
}

#email {
  font-size: 20px;
}

.email-wrapper {
  width: 100%;
}

.email-label {
  width: 100%;
}
</style>
